import PropTypes from 'prop-types';

export const File = PropTypes.shape({
    fileId: PropTypes.string.isRequired,
    name: PropTypes.string,
    type: PropTypes.string,
});

export default File;
